import type { CardListItemProps } from "./CardListItem.types"
import { getCardListItemStyles } from "./CardListItem.styles"
import { cn } from "@/utils/cn"

/**
 * CardListItem é um contêiner de layout que estiliza um item de lista.
 * Ele usa um layout de grid que pode ser customizado via props `cols` ou `gridCols`.
 */
export const CardListItem = ({ children, cols, className }: CardListItemProps) => {
  const styles = getCardListItemStyles(cols)
  return <div className={cn(styles.wrapper, className)}>{children}</div>
}
